export const environment = {
  production: true,
  verboseRoutes: false,
  apiBase: 'https://api.staging.learnerverified.com/',
  appBase: 'https://app.staging.learnerverified.com/',
  wss: 'wss://api.staging.learnerverified.com/cable',
  cdn: 'app.staging.learnerverified.com',
  octoproctorUrl: 'https://wkt.proctoring.app'
};
